import { useBaseCrudService } from 'framework/crud';
import { useKernelApi } from 'infrastructure/api';
import { RESOURCE_URL as EMPLOYEES_RESOURCE_URL } from 'domain/shared/employee';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { LoadingParams } from 'framework/list';
import getBackgroundCheckValidationSchema from '../createupdate/backgroundCheckValidationSchema';
export const UPDATE_BACKGROUND_CHECK = 'UPDATE_BACKGROUND_CHECK';
export const READ_BACKGROUND_CHECK_LIST = 'READ_BACKGROUND_CHECK_LIST';

const RESOURCE_URL = '/backgroundChecks';

const useEmployeeBackgroundCheckService = () => {
  const { sendGetRequest } = useKernelApi();
  const employeeId = useEmployeeId();
  const resourceUrl = `${EMPLOYEES_RESOURCE_URL}/${employeeId}${RESOURCE_URL}`;

  const baseCrudOperations = useBaseCrudService({
    singleResourceUrl: `${resourceUrl}/:id`,
    listResourceUrl: resourceUrl,
    useService: useKernelApi,
  });

  const getSearchParams = (request: LoadingParams) => {
    const params = [];
    params.push(`pageSize=${encodeURIComponent(request.pageSize)}`);
    params.push(`pageNumber=${encodeURIComponent(request.pageNumber)}`);

    if (request.sort && Object.keys(request.sort).length > 0) {
      const [sortKey, sortValue = ''] = Object.entries(request.sort)[0];
      params.push(`${encodeURIComponent(`sort[${sortKey}]`)}=${encodeURIComponent(sortValue)}`);
    }

    return params.join('&');
  };

  const search = async (request: any) => {
    const url = `${resourceUrl}?${getSearchParams(request)}`;
    const response = await sendGetRequest(url);

    return response.json();
  };

  const createBackgroundCheck = async (data: unknown) => {
    return baseCrudOperations.create(data);
  };

  const updateBackgroundCheck = async (id: string, data: unknown) => {
    return baseCrudOperations.update(id, data);
  };

  const deleteBackgroundCheck = async (id: string) => {
    return baseCrudOperations.deleteById(id);
  };

  return {
    ...baseCrudOperations,
    search,
    getValidationSchema: getBackgroundCheckValidationSchema,
    createBackgroundCheck,
    updateBackgroundCheck,
    deleteBackgroundCheck,
  };
};

export default useEmployeeBackgroundCheckService;
